import React, {createContext, useContext, useEffect, useState} from "react";
import {Redirect, Route, Switch, useHistory} from "react-router-dom";
import {useQuery} from "../react-tools";
import { USER_ROLE } from "../constant/user";
import {getLogin} from "../../api/cp";
import userAction from "../actions/user";
import { getRoles } from "../../lib/roles";
import Loading from "../components/Loading";
import Registration from "../components/Authorization/Registration";
import {LoginPage, LogoutPage} from "../components/Authorization";

export const UserContext = createContext(null);

export const UserProvider = ({children}) => {
    const [user, setUser] = useState(null);
    const [userLoading, setUserLoading] = useState(true);
    let history = useHistory();
    let query = useQuery();

    useEffect(async () => {
        setUserLoading(true);

        try {
            const user = await getLogin();
            setUser(user);
        } catch (e) {
        }

        setUserLoading(false);
    }, []);

    useEffect(() => {
        userAction.setUser(user);
    }, [user]);

    const handleRegistration = (user) => {
        setUser(user);
        history.push("/");
    }

    const hasRole = (role) => {
        if (!user?.role || !role) return false;
        return getRoles(user.role).includes(role);
    }

    if (userLoading) {
        return <Loading modal>Загрузка данных пользователя...</Loading>
    }

    if (!user) {
        return (
            <Switch>
                <Route path="/registration" exact>
                    <Registration onSuccess={(user) => handleRegistration(user)} />
                </Route>
                <Route path="/logout">
                    <Redirect to={query.get('back') || `/`} />
                </Route>
                <Route path="*">
                    <LoginPage onSuccess={(user) => setUser(user)} />
                </Route>
            </Switch>
        );
    }

    const context = {
        user,
        userIsAdmin: hasRole(USER_ROLE.ADMIN),
        userIsSuperAdmin: hasRole(USER_ROLE.SUPER_ADMIN),
    };

    return (
        <UserContext.Provider value={context}>
            <Switch>
                <Route path="/logout" exact>
                    <LogoutPage onSuccess={() => setUser(null)}>
                        <Redirect to={query.get('back') || `/`} />
                    </LogoutPage>
                </Route>
                <Route path="*">
                    {children}
                </Route>
            </Switch>
        </UserContext.Provider>
    );
}

export const useUserContext = () => useContext(UserContext);
